<template>
  <transition name="modal" v-if="isReady">
    <div class="modal fade show modal-container" :id="modalId">
      <div class="modal-dialog" :class="sizeClass">
        <div class="modal-content">
          <slot name="body" >
            ...
          </slot>

          <a href="#close-modal" data-dismiss="modal" rel="modal:close" class="close-modal "  @click="$emit('close')">Close</a>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
    export default {
      name: 'Modal',

      props: {
        size: {
          required: false,
          type: String,
        },

        id: {
          type: String,
        },
      },

      data() {
        return {
          isReady: false,
        }
      },

      mounted() {
        // doing this b/c we need to allow the modal to control it's own styling and when we create the modal inside a
        // component, it then acquires it's styling from parent container which causes issues when attempting to
        // control the layout of the modal content
        // no longer need to do this b/c we are moving to portal vue <portal-target name="destination">
        // if portal is used, we need to add <portal to="modal" v-if="isReady" > to contain this modal and a named portal in the app renderer
        document.body.appendChild(this.$el)
        let modalBackdrop = document.createElement('div')
        modalBackdrop.setAttribute('id', 'modal-backdrop')
        modalBackdrop.classList.add(`modal-backdrop`)
        modalBackdrop.classList.add(`show`)
        document.body.appendChild(modalBackdrop)
        this.$nextTick(() => {
          this.isReady = true
        })
      },

      created() {
        document.addEventListener('keyup', this.escapeKeyListener)
        // bootstrap requirement in v3.x
        document.body.classList.add('modal-open')
      },

      beforeDestroy() {
        // bootstrap requirement in v3.x
        document.body.className = document.body.className.replace('modal-open', '')
        document.getElementById('modal-backdrop').outerHTML = ''

        document.removeEventListener('keyup', this.escapeKeyListener)
      },

      computed: {
        hasFooterSlot() {
          return !!this.$slots['footer']
        },

        sizeClass() {
          if (this.size) {
            return `modal-${this.size}`
          }
        },

        modalId() {
          if (this.id) {
            return this.id
          }
          return ''
        },
      },

      methods: {
        escapeKeyListener: function(event) {
          if (event.keyCode === 27) {
            this.$emit('close')
          }
        },
      },
    }
</script>

<style scoped lang="scss">
  .modal {
    /* default is to display block */
    display: block;

    &.modal-fullscreen {
      /* in full screen we switch to flex */
      display: flex;
      .modal-dialog {
        width: 100%;
        //height: 100%;
        margin: 0;
        padding: 0;
        max-width: none;
      }

      .modal-content {
        height: auto;
        min-height: 100%;
        border-radius: 0;
        border: none;
      }
    }
  }

  .modal-mask {
    /*position: fixed;*/
    /*z-index: 9998;*/
    /*top: 0;*/
    /*left: 0;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*background-color: rgba(0, 0, 0, .5);*/
    /*display: table;*/
    transition: opacity .3s ease;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }


  a.close-modal {
    position: absolute;
    top: -7.5px;
    right: -7.5px;
    display: block;
    width: 25px;
    height: 25px;
    z-index: 999;
    text-indent: -9999px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    /*background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAA3hJREFUaAXlm8+K00Acx7MiCIJH/yw+gA9g25O49SL4AO3Bp1jw5NvktC+wF88qevK4BU97EmzxUBCEolK/n5gp3W6TTJPfpNPNF37MNsl85/vN/DaTmU6PknC4K+pniqeKJ3k8UnkvDxXJzzy+q/yaxxeVHxW/FNHjgRSeKt4rFoplzaAuHHDBGR2eS9G54reirsmienDCTRt7xwsp+KAoEmt9nLaGitZxrBbPFNaGfPloGw2t4JVamSt8xYW6Dg1oCYo3Yv+rCGViV160oMkcd8SYKnYV1Nb1aEOjCe6L5ZOiLfF120EjWhuBu3YIZt1NQmujnk5F4MgOpURzLfAwOBSTmzp3fpDxuI/pabxpqOoz2r2HLAb0GMbZKlNV5/Hg9XJypguryA7lPF5KMdTZQzHjqxNPhWhzIuAruOl1eNqKEx1tSh5rfbxdw7mOxCq4qS68ZTjKS1YVvilu559vWvFHhh4rZrdyZ69Vmpgdj8fJbDZLJpNJ0uv1cnr/gjrUhQMuI+ANjyuwftQ0bbL6Erp0mM/ny8Fg4M3LtdRxgMtKl3jwmIHVxYXChFy94/Rmpa/pTbNUhstKV+4Rr8lLQ9KlUvJKLyG8yvQ2s9SBy1Jb7jV5a0yapfF6apaZLjLLcWtd4sNrmJUMHyM+1xibTjH82Zh01TNlhsrOhdKTe00uAzZQmN6+KW+sDa/JD2PSVQ873m29yf+1Q9VDzfEYlHi1G5LKBBWZbtEsHbFwb1oYDwr1ZiF/2bnCSg1OBE/pfr9/bWx26UxJL3ONPISOLKUvQza0LZUxSKyjpdTGa/vDEr25rddbMM0Q3O6Lx3rqFvU+x6UrRKQY7tyrZecmD9FODy8uLizTmilwNj0kraNcAJhOp5aGVwsAGD5VmJBrWWbJSgWT9zrzWepQF47RaGSiKfeGx6Szi3gzmX/HHbihwBser4B9UJYpFBNX4R6vTn3VQnez0SymnrHQMsRYGTr1dSk34ljRqS/EMd2pLQ8YBp3a1PLfcqCpo8gtHkZFHKkTX6fs3MY0blKnth66rKCnU0VRGu37ONrQaA4eZDFtWAu2fXj9zjFkxTBOo8F7t926gTp/83Kyzzcy2kZD6xiqxTYnHLRFm3vHiRSwNSjkz3hoIzo8lCKWUlg/YtGs7tObunDAZfpDLbfEI15zsEIY3U/x/gHHc/G1zltnAgAAAABJRU5ErkJggg==");*/
  }
  @media only screen and (min-width: 768px) {
    a.close-modal {
      top: -12.5px;
      right: -12.5px;
      width: 30px;
      height: 30px;
    }
  }


  #donate a.close-modal {
    display: block;
  }


</style>
